// ========== Appeal Information ==========
export const CreateTabsList = ['appealer', 'description', 'executor'] as const;
export const AppealSources = [
  'request',
  'tenant',
  'dispatcher',
  'our_spb',
  'gis',
  'house_chat',
] as const;
export const AppealStatuses = ['new', 'performed', 'run', 'revoked'] as const;
export const AppealTypes = [
  'statement',
  'claim',
  'complaint',
  'notice',
  'letter',
  'proposal',
  'acknowledgement',
  'consultation',
] as const;
export const AppealRequesterTypes = [
  'tenant',
  'other_person',
  'employee',
  'other_employee',
  'our_spb_portal',
] as const;

// ========== Appeals Stats =============
export const AppealsStatsEnum = ['run', 'new', 'performed', 'overdue'] as const;

// ========== Create Appeal Mode ===========
export const AppealCreateMode = ['default', 'portal'] as const;

// ========== Applicant & Type ==========
export const ApplicantTypesList = ['tenant', 'worker', 'other'] as const;
export const OtherTypesList = ['physical', 'legal'] as const;

// ========== Appeal Employee Phone & File Types ==========
export const AppealEmployeePhoneTypes = [
  'cell',
  'work',
  'dispatcher',
  'home',
  'fax',
  'emergency',
] as const;

// ========== File Types ==========
export const AppealFileEncodingTypes = ['utf-8', 'cp1251'] as const;
export const AppealFileContentTypes = [
  'application/octet-stream',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/csv',
  'application/json',
  'application/xml',
  'text/html',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'audio/mpeg',
  'audio/wav',
  'video/mp4',
  'video/quicktime',
  'video/x-msvideo',
  'application/zip',
  'application/gzip',
  'application/x-tar',
  'application/x-rar-compressed',
] as const;

// ========== Организации для которых другая форма ответа в обращениях ==========
export const AnotherAnswerProviders: string[] = [
  '5feaf9e6a321830014f4d79d', // ООО "УК ПУЛЬС"
  '54d9da76f3b7d43980796cb3', // ООО "УК "Лайф-Сервис"
  '54d9ffe9f3b7d439807bb8ee', // ООО "СХОДНЕНСКАЯ-1"
  '59f7172f98b00100327d9b31', // ООО "Клининговый центр"
  '5a2548763588ec00300758c3', // ООО "ВОЛЖСКАЯ-1
  '5a254b9e3588ec0030075957', // ООО "МИТИНО-1"
  '5a2bcca27e1a83001d004d45', // ООО "ПРОФ СЕРВИС МИТИНО-ПАРК"
  '5ea97d1b1bbb2c0012f0896c', // ООО "ЛАЙФ ЭКСПЛУАТАЦИЯ"
  '60f83938fae4190011d8f061', // ООО "УК "МЕРКУРИЙ ПОКРОВСКОЕ""
  '61961b52f0141400146d3819', // ООО "ПУЛЬС ПРЕМЬЕР"
  '62a2f0929e29b1001a31490f', // ООО "УК "Петровский Остров""
  '660bdf84ad9a9027e839b77b', // ООО "ТВС"
  '67c818c00fd3ded4d425be8a', // ООО "Сан Сити Сервис",
  '526234b3e0e34c4743822066', // ООО "Эксплуатация Главстрой-СПб"
];
